<template>
    <div class="buttons_container">
        <div class="buttons-wrapper">
            <button 
                class="button secundary" id="atras"
                @click="handleBack"         
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon_arrow">
                    <path d="M9.57043 18.8191C9.38043 18.8191 9.19043 18.7491 9.04043 18.5991L2.97043 12.5291C2.68043 12.2391 2.68043 11.7591 2.97043 11.4691L9.04043 5.39914C9.33043 5.10914 9.81043 5.10914 10.1004 5.39914C10.3904 5.68914 10.3904 6.16914 10.1004 6.45914L4.56043 11.9991L10.1004 17.5391C10.3904 17.8291 10.3904 18.3091 10.1004 18.5991C9.96043 18.7491 9.76043 18.8191 9.57043 18.8191Z" fill="#0046DE"/>
                    <path d="M20.5004 12.7491H3.67043C3.26043 12.7491 2.92043 12.4091 2.92043 11.9991C2.92043 11.5891 3.26043 11.2491 3.67043 11.2491H20.5004C20.9104 11.2491 21.2504 11.5891 21.2504 11.9991C21.2504 12.4091 20.9104 12.7491 20.5004 12.7491Z" fill="#0046DE"/>
                </svg>
                <span style="color: var( --primary)">{{ backStepButtonText }}</span>
            </button>
            <button 
                class="button primary rounded" 
                @click="handleNext" 
                :disabled="!nextStepButtonActive"
            >
                <span>{{ nextStepButtonText }}</span>
            </button>
        </div>
    </div> 
</template>

<script>
export default {
    name: 'NavegationButtons',
    props: [
        'nextStep',
        'backStep',
        'nextStepButtonActive',
        'nextStepButtonText',
        'backStepButtonText',
        'nextStepCallback'
    ],
    methods: {
        handleBack() {
            if(/^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(this.backStep)) window.location.href = this.backStep;
            else this.$store.dispatch('goBack');
        },
        handleNext() {
            if(this.nextStepCallback) this.nextStepCallback();
            else this.$store.dispatch('goNext', this.nextStep);
        },
    }
}

</script>

<style>
    .buttons_container{
        margin-top: 40px;
    }
    .buttons-wrapper {
        display: flex;
        justify-content: flex-start;
    }
    .icon_arrow {
        margin-right: 4px;
        display: flex;
        align-items: center;
    }
    @media (min-width: 1024px){
        #atras {
            padding: 12px 0;
            width: 80px !important;
            justify-content: left;
        }
    }
    /* MOVIL */
    @media (max-width: 768px){
        .buttons_container{
            margin: 40px 0;
            box-sizing: border-box;
        }
        .buttons-wrapper {
            display: flex;
            padding: 16px 0 24px 0;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            align-self: stretch;
        }
    }
</style>